import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadConfig } from './lib/config';
import { resolveDomain } from './api/domains';
import { hostMode, isPlatformHost } from './lib/hostSite';
import App from './App';
import HostedSite from './components/HostedSite';
import './styles/index.css';

const rootEl = document.getElementById('root');

/**
 * docs/Decisions.md D60 item 4: on an organization's website host the app
 * renders only its template site. Platform hosts never ask; if the lookup
 * fails, the app runs as usual.
 */
async function detectHostMode(config) {
  const hostname = window.location.hostname;
  if (isPlatformHost(hostname, config.domain)) return { mode: 'app' };
  try {
    return hostMode(await resolveDomain(hostname), config.domain);
  } catch {
    return { mode: 'app' };
  }
}

// Config loads before first render so getConfig() is synchronous everywhere.
loadConfig()
  .then(async (config) => {
    document.title = config.productName || document.title;
    const host = await detectHostMode(config);
    createRoot(rootEl).render(
      <React.StrictMode>
        {host.mode === 'website' ? (
          <HostedSite slug={host.slug} portalOrigin={host.portalOrigin} />
        ) : (
          <App />
        )}
      </React.StrictMode>
    );
  })
  .catch((err) => {
    rootEl.innerHTML =
      '<div class="mx-auto my-16 max-w-lg px-4 font-sans">' +
      '<h1>Configuration error</h1>' +
      '<p>The application could not load its runtime configuration ' +
      '(<code>/config.json</code>). If you are developing locally, run ' +
      '<code>npm run sync-config</code> first.</p>' +
      `<pre>${String(err && err.message ? err.message : err)}</pre></div>`;
  });
